import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { GeoSetTargetable } from '@feathr/blackbox';
import { ActionMenuCell, ArchiveModal } from '@feathr/components';
import { getIconForAction, useToggle } from '@feathr/hooks';

interface IGeoFiltersOptionsProps {
  onEdit: (targetable: GeoSetTargetable) => void;
  onSetDefault: (targetable: GeoSetTargetable) => void;
  targetable: GeoSetTargetable;
}

function GeoFiltersOptions({
  onEdit,
  onSetDefault,
  targetable,
}: Readonly<IGeoFiltersOptionsProps>): JSX.Element {
  const { t } = useTranslation();
  const [isArchiveModalOpen, toggleArchiveModalOpen] = useToggle(false);

  const handleEdit = (): void => {
    onEdit(targetable);
  };

  const handleSetDefault = (): void => {
    onSetDefault(targetable);
  };

  return (
    <>
      <ActionMenuCell
        items={[
          <ActionMenuCell.Item
            key={'edit'}
            name={'edit-geoFilter'}
            onClick={handleEdit}
            prefix={getIconForAction('edit')}
          >
            {t('Edit')}
          </ActionMenuCell.Item>,
          <ActionMenuCell.Item
            key={'assign'}
            name={'assign-geoFilter-as-default'}
            onClick={handleSetDefault}
            prefix={getIconForAction('check')}
          >
            {t('Assign as default')}
          </ActionMenuCell.Item>,
          <ActionMenuCell.Item
            key={'delete'}
            name={'delete-geoFilter'}
            onClick={toggleArchiveModalOpen}
            prefix={getIconForAction('delete')}
            theme={'danger'}
          >
            {t('Delete')}
          </ActionMenuCell.Item>,
        ]}
        name={'geoFilters-options'}
      />

      {isArchiveModalOpen && (
        <ArchiveModal
          confirmButtonText={t('Delete')}
          description={t('Your campaigns will not be affected by this action.')}
          method={'archive'}
          model={targetable}
          onClose={toggleArchiveModalOpen}
          opened={isArchiveModalOpen}
          t={t}
          title={t('Delete Geofilter Set')}
        >
          {t('The geofilter settings will be automatically reapplied to all associated campaigns.')}
        </ArchiveModal>
      )}
    </>
  );
}

export default observer(GeoFiltersOptions);
